export default "__VITE_ASSET__2a782f62__"